module.exports = __webpack_public_path__ + "img/poker-h07.392d0d63.svg";